import dayjs from 'dayjs';
import { SalesReportDateRangePresetType } from './SalesReport.types';

export const DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_RANGE_PRESETS: SalesReportDateRangePresetType[] = [
  {
    key: 'today',
    labelKey: 'filters.presets.today',
    getRange: () => ({
      start: dayjs().format(DATE_FORMAT),
      end: dayjs().format(DATE_FORMAT),
    }),
  },
  {
    key: 'this_week',
    labelKey: 'filters.presets.this_week',
    getRange: () => ({
      start: dayjs().startOf('week').format(DATE_FORMAT),
      end: dayjs().format(DATE_FORMAT),
    }),
  },
  {
    key: 'this_month',
    labelKey: 'filters.presets.this_month',
    getRange: () => ({
      start: dayjs().startOf('month').format(DATE_FORMAT),
      end: dayjs().format(DATE_FORMAT),
    }),
  },
];

export const DEFAULT_PRESET_KEY = 'this_month';

export const DEFAULT_PAGE_SIZE = 10;

// OJO: esta key NO debe empezar por 'subsidiary'. setQueryDefaults(['subsidiary'])
// (config de sucursal, staleTime 1h) hace match por prefijo en TanStack Query, así
// que ['subsidiary', 'users'] heredaba ese staleTime y el listado no refetcheaba
// nunca -- quedaba vacío y no se podían reasignar pedidos.
export const SUBSIDIARY_USERS_QUERY_KEY = ['subsidiary-users'];
